import { COLOR_MODE } from '../../../shared/constants/colorMode.js'

import { areFilterConfigsEqual } from './filterUtils.js'

export function buildColorModeLegendItems(modeConfig, products) {
  if (!modeConfig || !products?.length) return []

  const uniqueKeys = modeConfig.getLegendKey
    ? new Set(products.map(modeConfig.getLegendKey).filter((key) => key != null))
    : new Set()

  return modeConfig.buildItems(uniqueKeys)
}

export function getColorModeFilterActive(filterId, activeFiltersConfig, defaultFiltersConfig) {
  if (!filterId || !activeFiltersConfig || !defaultFiltersConfig) return false

  return !areFilterConfigsEqual(activeFiltersConfig[filterId], defaultFiltersConfig[filterId])
}

export function encodeColorModeLegendHoverValue(colorMode, key) {
  switch (colorMode) {
    case COLOR_MODE.INSOLATION:
      return `insolation:${key}`
    case COLOR_MODE.COMPARE:
      return `compare:${key}`
    case COLOR_MODE.CATEGORY:
      return `category:${String(key)}`
    default:
      return String(key)
  }
}

export function resolveColorModeHoveredLegendKey({
  hoveredProduct,
  colorMode,
  colorModeDeciles,
  modeConfig,
}) {
  if (!hoveredProduct) return null
  if (colorMode === COLOR_MODE.COMPARE) return colorModeDeciles?.get(hoveredProduct.uuid) ?? null
  return modeConfig?.getLegendKey ? modeConfig.getLegendKey(hoveredProduct) : null
}

export function isColorModeLegendKeyActive({
  legendKey,
  filterId,
  toFilterValue,
  matchesFilterValue,
  activeFiltersConfig,
  defaultFiltersConfig,
}) {
  const modeFilterActive = getColorModeFilterActive(filterId, activeFiltersConfig, defaultFiltersConfig)

  if (!modeFilterActive) return false
  if (matchesFilterValue) return matchesFilterValue(activeFiltersConfig?.[filterId], legendKey)
  if (!toFilterValue) return false

  return areFilterConfigsEqual(activeFiltersConfig?.[filterId], toFilterValue(legendKey))
}

export function getNextColorModeFiltersConfig({
  activeFiltersConfig,
  defaultFiltersConfig,
  filterId,
  toFilterValue,
  legendKey,
}) {
  if (!filterId || !toFilterValue || !defaultFiltersConfig) {
    return activeFiltersConfig ?? {}
  }

  const nextValue = toFilterValue(legendKey)
  const isAlreadyActive = areFilterConfigsEqual(activeFiltersConfig?.[filterId], nextValue)

  return {
    ...(activeFiltersConfig ?? {}),
    [filterId]: isAlreadyActive ? defaultFiltersConfig[filterId] : nextValue,
  }
}